import api from "../utils/api";

/**
 * Auth service for backward compatibility
 * Note: Main auth functionality is now in AuthContext (useAuth hook)
 * These functions are kept for components that haven't migrated yet
 */

export function setToken(token) {
  localStorage.setItem("token", token);
}

export function getToken() {
  return localStorage.getItem("token");
}

export function logout() {
  localStorage.removeItem("token");
}

// Function to get stored user data (deprecated - use useAuth hook)
export function getStoredUser() {
  return null; // No longer stored in localStorage
}

export function isAuthenticated() {
  const token = getToken();
  if (!token) {
    return false;
  }

  try {
    // Check if token is expired (basic JWT check)
    const payload = JSON.parse(atob(token.split(".")[1]));
    const currentTime = Date.now() / 1000;

    if (payload.exp && payload.exp < currentTime) {
      // Token is expired, remove it
      logout();
      return false;
    }

    return true;
  } catch (error) {
    // If token is malformed, consider it invalid
    logout();
    return false;
  }
}

// Function to get user role from token
export function getUserRole() {
  const token = getToken();
  if (!token) {
    return null;
  }

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.role;
  } catch (error) {
    return null;
  }
}

// Function to check if user is admin
export function isAdmin() {
  return getUserRole() === "admin";
}

// Function to check if user is admin team
export function isAdminTeam() {
  return getUserRole() === "admin_team";
}

// Function to check if user is investor
export function isInvestor() {
  return getUserRole() === "investor";
}

// Function to validate token with backend
export async function validateToken() {
  try {
    const response = await api.get("/api/auth/validate");
    return response.status === 200;
  } catch (error) {
    logout();
    return false;
  }
}

// Function to get current user information from token
export function getCurrentUser() {
  const token = getToken();
  if (!token) {
    return null;
  }

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return {
      userId: payload.userId,
      username: payload.username,
      role: payload.role,
      investorId: payload.investorId,
    };
  } catch (error) {
    return null;
  }
}

// Function to get current username
export function getCurrentUsername() {
  const user = getCurrentUser();
  return user ? user.username : null;
}